import React from "react";
import { Cell, Pie, PieChart } from "recharts";

import styles from "./business-impact.module.scss";
import { ValueDriverId } from "./sample";

const SIZE = 190;

export const DRIVER_COLOR: Record<ValueDriverId, string> = {
  productivity: "var(--driver-productivity)",
  absenteeism: "var(--driver-absenteeism)",
  healthClaims: "var(--driver-health-claims)",
  retention: "var(--driver-retention)",
};

// The pale retention colour vanishes on the meter's track, so the meters
// use a deeper shade of it; the ring keeps the pale one.
export const METER_COLOR: Record<ValueDriverId, string> = {
  ...DRIVER_COLOR,
  retention: "var(--driver-retention-meter)",
};

/**
 * The value drivers as a ring with the total in its centre. The ring is a
 * picture of the figures the cards and legend state in words, so it is one
 * image with a text description rather than something a screen reader walks.
 */
const ValueDriverRing = ({
  drivers,
  label,
  totalLabel,
  total,
}: {
  drivers: { id: ValueDriverId; amount: number }[];
  label: string;
  totalLabel: string;
  total: string;
}) => (
  <div
    className={styles["ring"]}
    role="img"
    aria-label={label}
    style={{ width: SIZE, height: SIZE }}
  >
    <div aria-hidden="true">
      <PieChart width={SIZE} height={SIZE}>
        <Pie
          data={drivers}
          dataKey="amount"
          nameKey="id"
          innerRadius={64}
          outerRadius={SIZE / 2}
          startAngle={90}
          endAngle={-270}
          paddingAngle={2}
          stroke="none"
          isAnimationActive={false}
        >
          {drivers.map((driver) => (
            <Cell key={driver.id} fill={DRIVER_COLOR[driver.id]} />
          ))}
        </Pie>
      </PieChart>
    </div>
    <div className={styles["ring-centre"]} aria-hidden="true">
      <span className={styles["ring-total-label"]}>{totalLabel}</span>
      <span className={styles["ring-total"]}>{total}</span>
    </div>
  </div>
);

export default ValueDriverRing;
